import GenericException from './GenericException'

export default class NotImplementedError extends GenericException {
  constructor() {
    super({
      name: NotImplementedError.name,
      message: 'method/class not yet implemented.',
      action: 'implement this method/class'
    })
  }
}
